import { ProductId } from './common';
import { getClientInfo } from './getClientInfo';
import { appInfo } from './appInfo';
/**
 * 获取用户token
 */
export function getUserToken() {
    return new Promise(function (resolve) {
        getClientInfo({
            forceUpdate: false,
            complete: function () {
                var userToken;
                switch (appInfo.productId) {
                    case ProductId.Ymstock:
                        userToken = {
                            emoneyToken: appInfo.token,
                            appId: appInfo.productId
                        };
                        if (appInfo.appVersion) {
                            ;
                            userToken.mv = Number(appInfo.appVersion.replace(/\./g, ''));
                        }
                        if (appInfo.vd) {
                            ;
                            userToken.vd = appInfo.vd;
                        }
                        var ar = appInfo.getParam('ar');
                        if (ar) {
                            ;
                            userToken.ar = ar;
                        }
                        break;
                    case ProductId.Ycstock:
                        userToken = {
                            'Ykt-Token': appInfo.token
                        };
                        break;
                    default:
                        userToken = {
                            authorization: appInfo.token
                        };
                        if (appInfo.productId) {
                            userToken.appId = appInfo.productId;
                        }
                        break;
                }
                resolve(userToken);
            }
        });
    });
}
//# sourceMappingURL=getUserToken.js.map